var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowForwardIos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "arrow_forward_ios"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_700_1337",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 10,
    height: 10
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 10,
    height: 10,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_700_1337)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "arrow_forward_ios_2",
    d: "M3.05769 8.71315C2.96795 8.6234 2.92308 8.51964 2.92308 8.40185C2.92308 8.28407 2.96795 8.18031 3.05769 8.09056L6.14824 5.00001L3.04728 1.89904C2.9618 1.81358 2.91907 1.71395 2.91907 1.60017C2.91907 1.48639 2.96528 1.3833 3.05769 1.29089C3.14049 1.20809 3.24252 1.16669 3.36378 1.16669C3.48503 1.16669 3.58706 1.20809 3.66986 1.29089L7.09855 4.71556C7.14448 4.7615 7.1772 4.80784 7.1967 4.85458C7.2162 4.90132 7.22594 4.9498 7.22594 5.00001C7.22594 5.05023 7.2162 5.0987 7.1967 5.14544C7.1772 5.19218 7.14448 5.23852 7.09855 5.28446L3.65944 8.72356C3.56703 8.81598 3.46501 8.85872 3.35336 8.85177C3.24171 8.84483 3.14316 8.79862 3.05769 8.71315Z",
    fill: "#9CA3AF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowForwardIos);
export default __webpack_public_path__ + "static/media/arrow_forward_ios.b0abf78d749ea9c72ac1761f3c63b7a6.svg";
export { ForwardRef as ReactComponent };